import React,{useState,useEffect,useRef} from "react";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
    CalendarFold,
    ChevronDown,
    ChevronUp,
  ImageUp} from 'lucide-react';import Snackbar from "../../../Snackbar";

import {  getAllSubCoursesByCourseId } from "../../../store/actions/CreateContent/OrganizeAPI/SubCoursesAPIs";

import BatchMilestones from "./BatchMilestones";
import BatchLeftPopup from "./BatchLeftPopup";
import { getDripItem } from "./getDripItem";
import DripItemFields from "./DripItemFields";


const BatchSubCourses =({selectCoursePopUp,batch,contentDripArr})=>{

     const dispatch = useDispatch();
         const user = useSelector((state)=>state?.user?.user);
               const [activeFilterOne, setActiveFilterOne] =useState(true);
                       const [activeFilterTwo, setActiveFilterTwo] =useState(true);
                       const [activeFilterThree, setActiveFilterThree] =useState(false);
                       const [activeFilterFour, setActiveFilterFour] =useState(false);
                       const [activeFilterASC, setActiveFilterASC] =useState(true);
                       const [activeFilterDESC, setActiveFilterDESC] =useState(false);
                       const [openSubCourseInfoPopUp, setOpenSubCourseInfoPopUp] =useState(false);
                        const [currentDripItemStatus,setCurrentDripItemStatus]=useState(true)
         const [snackbarVisible, setSnackbarVisible] = useState(false);
                          const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                          const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                    
                                  const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
                       const showSnackbar = () => {
                         setSnackbarVisible(true);
                       };
                      
                       const hideSnackbar = () => {
                         setSnackbarVisible(false);
                       };
                 
                 
                            
                            
                         
                        const [animate, setAnimate] = useState(false);
          
           const [loader , setLoader] =useState({status:true});
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
      const [openAppDesignPopUp,setopenAppDesignPopUp]  = useState(false);
      const [openAppDesignPopUpInnerContent,setopenAppDesignPopUpInnerContent]  = useState("appThemes");

      
const token = useSelector((state)=>state?.course?.course?.token);
       const currentToken = useSelector((state)=>state?.user?.user?.token);
       const user_email = useSelector((state)=>state?.user?.user?.user_email
      );
      
      const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
      
      const courseData = useSelector((state)=>state?.course?.course);
      
      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
     
        const appId = useSelector((state)=>state?.app?.app?.ID);
        const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
          
           const [visibility,setVisibility] =useState("public");
           const [orderBy,setOrderBy] =useState("ASC");
           const [itemArr, setItemArr] = useState([]);
           const [itemReorderArr, setItemReorderArr] = useState([]);
           const [itemId, setItemId] = useState("");
           const [deleteItemPopUp, setDeleteItemPopUp] = useState(false);
           const [itemArrLoading, setItemArrLoading] = useState([{},{},{}]);
           const [openContentInFolder, setOpenContentInFolder] = useState("");
           const [openMilestoneForSubCourse, setOpenMilestoneForSubCourse] = useState("");
           const [createNewMileStone, setCreateNewMileStone] = useState(false);
           const [openMileStone, setOpenMileStone] = useState(false);
                 
                                  const [currentItem, setCurrentItem] = useState("");
                                  const [currentDripItem, setCurrentDripItem] = useState("");
 const [subCourseItem ,setSubCourseItem] =useState({});



      useEffect((e)=>{
      
    fireGetAllSubCoursesByCourse();
    setOpenMilestoneForSubCourse("");
        },[visibility,orderBy,postIdCourse]);
  const fireGetAllSubCoursesByCourse=()=>{
          setItemArr([])
         
        
                
          // if(visibility=='public'){setActiveFilterTwo(true)}
          // if(openAppDesignPopUp){setActiveFilterTwo(true);setVisibility('public');}
          
        
          setItemArrLoading([{},{},{}])
        // Popup When Course is not selected
          if(courseData){}else{selectCoursePopUp(true);}
        
        setLoader({status:true});
            // console.log({
            //     token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
            //     appToken:AppToken,visibility:visibility,orderBy:orderBy
            //     });
              const apiData = dispatch(getAllSubCoursesByCourseId({
                token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
                appToken:AppToken,visibility:visibility,orderBy:orderBy,appId:appId,appAllottedToken:appAllottedToken
                }));
              /* get response as Promise   */
              apiData.then(response => {
                // console.log(response)
        
                if(response){
                 
                  if(response){
                setResponseMessage(response?.message);
                setSnackbarColor("rgba(144, 202, 249,1)");
              
                if(response?.subCourses)  {setItemArr(response?.subCourses); 
        
                  const reorderArray = response?.subCourses.map(item => ({
                    ID: item.ID,
                    menuOrder: item.menuOrder
                }));
                setItemReorderArr(reorderArray);
                setOpenMilestoneForSubCourse(reorderArray.length?reorderArray[0]:[])
                //  console.log(reorderArray)
               setTimeout(()=>{
               setOpenMileStone(true)
            },1000)
                }else{setItemArr([]);};
                setItemArrLoading([]);
            setLoader({status:false});
            
            // setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
            },1000)
               }else{
            //     setResponseMessage("Something Went Wrong...");
                  
            //     setSnackbarColor("#958FDA");
            //   //  selectCoursePopUp(true);
                
                 
            // setLoader({status:false});
            // setItemArrLoading([{},{},{}]);
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
               }
                  
                // dispatch({
                //   type: "UPDATE_APP_TOKEN",
                  
                //   payload:response?.course?.AppToken
                // });  
              //  console.log(response?.course);
             
               // 
               if(response?.logout){
                // pop up response?.logoutInfo
                //console.log(response?.logoutInfo)
            
                setResponseMessage("You are Logged Out!!!");
                  
                setSnackbarColor("#958FDA");
               selectCoursePopUp(true);
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                setTimeout(()=>{
                  dispatch({type:"LOGOUT"});
            
                },3000)
                
              }
            /* resetting Login input Fields */
            
                }else{
                  setResponseMessage("Something Went Wrong...");
                  
                  setSnackbarColor("#958FDA");
                 selectCoursePopUp(true);
                 setItemArrLoading([{},{},{}]);
                   
              setLoader({status:false});
              
              setSnackbarVisible(true);
              setTimeout(()=>{
                
                setSnackbarVisible(false);
               
                 
              },3000)    }
            
              }).catch(error => {
             
                //popup of error Info
                setResponseMessage("Something Went Wrong...");
                  
                setSnackbarColor("#958FDA");
               selectCoursePopUp(true);
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                console.error(error);
              });
         }

        
         
         const flattenedData = itemArr!=[]?Object.values(itemArr):'';

         const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';
 
    



 
    return (<>
        {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}
        <div  align="left" className=" " style={{background:"#ffffff",borderRadius:"25px"}}> 
       
        <div className="" style={{}} > 
      
<h3 style={{padding:"10px"}}align="left">{flattenedData?.length?"Showing " 
             +(flattenedData?.length):"No Content Found"}
              {activeFilterTwo?flattenedData?.length>1?" Subcourses"
             :flattenedData?.length?" Subcourse":"":""} in Course- <span style={{ fontSize: 14, fontWeight: 900 }}> {courseData?.productName} </span> - Drip Settings for <span style={{ fontSize: 14, fontWeight: 900 }}>({batch.batchName})</span> 
              
              </h3>
        <div  style={{alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}>
            
        {flattenedDataLoading?.length==0?flattenedData?.length?flattenedData?.map((item, index) => 
        
        (<div  index={index} key={item?.ID}   style={{position:"relative",margin:"10px",background:"#f9f9f9",borderRadius:"15px"}}  >

            <div style={{ display: "flex",
        justifyContent:"space-between",flexWrap:"wrap"}}>
       
          <div style={{ display: "flex",gap:"10px",
        justifyContent:"left"}}>
       
       
            
<div onClick={()=>{setOpenMilestoneForSubCourse(item)
         
        }}
         style={{height:"70px",borderRadius:"5px",width:"100px",background:"#f1f1f1",display:"flex",justifyContent:"center",alignItems:"center"}}>
            <ImageUp size={40} color={"#aaaaaa"} /></div>
<div style={{display:"flex",alignItems:"center",fontSize:"20px",fontWeight:"900"}}>
   <div> <div>  <span className="hideXsForApp">Sub-course #</span>{index+1} : {item?.Name}

</div>
<div>
<DripItemFields drip={getDripItem(item?.ID, contentDripArr)} />
</div></div></div>


</div>

<div></div>
             <div  className="" style={{padding:"10px",background:"",marginTop:"5px",display: "flex",
        justifyContent:"space-between"}}> 
 <div  style={{padding:"5px",border:"3px solid rgba(144, 202, 249,1)",marginTop:"5px",fontSize:"14px",padding:"2px 10px",display:"flex",
            justifyContent:"space-between",alignItems:"center",height:"35px",gap:"5px",
                borderRadius:"5px",cursor:"pointer"}} 
                onClick={()=>{setCurrentItem(item);setCurrentDripItem(getDripItem(item?.ID, contentDripArr));
                setCurrentDripItemStatus(true)}}><CalendarFold size={20} color={"rgba(144, 202, 249,1)"}/>{getDripItem(item?.ID, contentDripArr)?"Update":"Add"} Drip</div>  
{openMileStone&&openMilestoneForSubCourse?.ID==item?.ID?<div onClick={()=>{setOpenMilestoneForSubCourse(item)
         
          setOpenMileStone(false)
        }} onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave} style={{background:"#fff",color:"#565283",position:"relative",zIndex:99,
                     padding:"10px",margin:"5px",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0621)"
                     ,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                         <ChevronUp strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" 
                     style={{padding:"2px",cursor:"pointer"}}/> <span>Close</span></div>:
                     <div onClick={()=>{setOpenMilestoneForSubCourse(item)
         
          setOpenMileStone(true)
        }} onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave} style={{background:"#fff",color:"#565283",position:"relative",zIndex:99,
                     padding:"10px",margin:"5px",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0621)"
                     ,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}> <ChevronDown strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" 
                     style={{padding:"2px",cursor:"pointer"}}/> <span>Open</span> </div>}
</div>
            
</div>{openMileStone&&openMilestoneForSubCourse?.ID==item?.ID?
<BatchMilestones setOpenMilestoneForSubCourse={setOpenMilestoneForSubCourse} 
selectCoursePopUp={selectCoursePopUp} SubCourseData={openMilestoneForSubCourse}
 setCreateNewMileStone={createNewMileStone} contentDripArr={contentDripArr} />   :""} </div>)):"":""}
{flattenedDataLoading?flattenedDataLoading?.map((item, index) => 
        (<div  index={index} key={item?.ID} style={{background:"#fff", margin:"10px",marginTop:"15px",
        marginRight:"15px",position:"relative",borderRadius:"10px",overflow:"hidden",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.021)"}} >
   
   {/* <div onClick={()=>{}}
           onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave}  className="subCoursePlayBtnLoading text-linetw" style={{}}>
          <Play strokeWidth={3}  size={30}  className="subCoursePlayBtnIcon"  color="#fff"/>
        </div> */}
        <div  style={{display:"flex",position:"absolute",top:"0px",cursor:"pointer",justifyContent:"space-between" ,width:"100%"}} 
          > 
         
            <div   
          className="">
          <div className="text-linetw" onClick={()=>{}}
           onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
         style={{padding:"15px",width:"15px",margin:"5px",borderRadius:"5px",cursor:"pointer"}}/>
           
           </div>
          <div   
          className="" style={{width:"60px"}}>
          <div onClick={()=>{}} className="text-linetw"
           onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
            style={{padding:"15px",width:"15px",margin:"5px",borderRadius:"5px",cursor:"pointer"}}></div>
           <div onClick={()=>{}} className="text-linetw"
           onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
            style={{padding:"15px",width:"15px",margin:"5px",borderRadius:"5px",cursor:"pointer"}}> </div> 
           
           </div>
           </div>
            
<div style={{height:"150px",width:"100%",background:"#f1f1f1",display:"flex",justifyContent:"center",alignItems:"center"}}><ImageUp size={90} color={"#aaaaaa"} /></div>





        <div  className="" style={{padding:"10px",background:"",marginTop:"5px", display: "grid",
        gridTemplateColumns: "85% 15%"}}>
        <div  className="ellipsisTitle" style={{}}></div> 
        <div    align="right"
          className="">
         <div onClick={()=>{}} className="text-linetw"
           onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
            style={{padding:"15px",width:"15px",margin:"5px",borderRadius:"5px",cursor:"pointer"}}> </div> 
           
           </div>
        </div><div  className="" style={{padding:"10px",background:"",marginTop:"5px", display: "grid",
        gridTemplateColumns: "40% 20% 40%"}}> 
<div className="text-linetw" style={{padding:"15px",margin:"5px",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0621)"}}> <div ></div></div>
<div className=""> </div><div className="text-linetw"  style={{padding:"15px",margin:"5px",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.021)"}}></div>
</div>
</div>)):""} 
          </div>

          {flattenedDataLoading?.length==0?flattenedData?.length?"": <div align="center"style={{margin:"15px",height:"140px",padding:"10px",borderRadius:"15px",background:"rgba(255,114,94,0.1)"}}><h3 style={{"textAlign":"center",
       
    }}> Opps... <span className="coloredTextV1">No Sub Course Found !!!</span>{activeFilterThree?" Deleted Sub-Courses Will Show Up Here..."
      :" Create A New Sub Course And Add Contents."}  </h3>
    <h5>
       </h5>
    </div>:""}
          </div><div  >
        
  
             



</div>
        




          
      
      {currentDripItemStatus&&currentItem?.ID?<BatchLeftPopup
       setCurrentDripItemStatus={()=>{ setCurrentDripItemStatus(false)}}
       contentDripArr={contentDripArr}
       currentDripItemStatus={currentDripItemStatus}
      currentItem={currentItem}
        currentDripItem={currentDripItem}
        onClose={()=>{setCurrentDripItem("")}}
        onAdded={()=>{}}
      />:""}
    

        
        </div></>)
}
export default BatchSubCourses;

